// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xGb3","signatureBlock":"Footer_signatureBlock__FjjCb","signature":"Footer_signature__2MnLF"};